import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { AuthenticationService } from '@auth/services/authentication.service';

/**
 * Intercepts outgoing HTTP requests to attach an Authorization header
 * if a user and token are present.
 *
 * - Clones the original request with credentials.
 * - Appends the `Authorization` header using a bearer token from localStorage.
 *
 * @param req - The original HTTP request.
 * @param next - The next handler in the HTTP pipeline.
 * @returns An observable of the HTTP event stream.
 */
export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const authenticationService = inject(AuthenticationService);
  const user = authenticationService.userValue;
  const token = localStorage.getItem('authToken');

  // Clone the request to include credentials
  let authRequest = req.clone({ withCredentials: true });

  // Add Authorization header if user and token exist
  if (user && token) {
    authRequest = authRequest.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }

  return next(authRequest);
}
